var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-item table",style:(_vm.style),attrs:{"id":_vm.widget.object.wid}},[_c('TableViewer',{attrs:{"settings":_vm.widget.object.table,"height":_vm.widget.position.heightPixels}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }